export type MagicLinkConfirmationOperation = 'inspect' | 'consume';

const MAX_PROOF_LENGTH = 8192;

/**
 * Read the opaque, server-signed proof from the URL fragment. The fragment is
 * not sent in HTTP requests or referrer headers. The proof is deliberately a
 * cross-browser bearer link; cryptographic validation remains server-side.
 */
export function proofFromMagicLinkFragment(fragment: string): string | null {
  const raw = fragment.startsWith('#') ? fragment.slice(1) : fragment;
  if (!raw || raw.length > MAX_PROOF_LENGTH + 16) return null;

  const params = new URLSearchParams(raw);
  if (
    [...params.keys()].some((key) => key !== 'proof') ||
    params.getAll('proof').length !== 1
  ) {
    return null;
  }
  const proof = params.get('proof');
  if (
    !proof ||
    proof.length > MAX_PROOF_LENGTH ||
    !/^mlc1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(proof)
  ) {
    return null;
  }
  return proof;
}

export function magicLinkConfirmationUrl(
  apiBaseUrl: string,
  operation: MagicLinkConfirmationOperation,
): string {
  return new URL(
    `/auth/magic-link/confirmation/${operation}`,
    apiBaseUrl,
  ).toString();
}
